/**
 * Configuration constants for WorkDay Dashboard
 */

export const CHART_COLORS = {
    attendance: '#22c55e',
    late: '#ef4444',
    leave: '#3b82f6',
    remote: '#a855f7',
} as const

export const DEPARTMENT_COLORS = [
    '#3b82f6',
    '#22c55e',
    '#f59e0b',
    '#ef4444',
    '#8b5cf6',
    '#ec4899',
    '#06b6d4',
    '#84cc16',
    '#f97316',
    '#6366f1',
] as const

export type DrillLevel = 'company' | 'department' | 'employee'

export interface DrillState {
    level: DrillLevel
    departmentId?: number
    departmentName?: string
}
